import { useEffect } from 'react';
import { u as useHandlerRef } from './useHandlerRef-AN2C5yL5.js';

/**
 * The OnRootContainerMousedown component ensures that `mousedown` event listener are
 * cleaned-up when it ( or its ancestor ) is un-mounted. This is useful to prevent leaving
 * unused listener attached after a un-mounted when the parent's lifecycle control's child
 * mount states
 */
const OnRootContainerMousedown = ({
  children,
  handler: handlerArg,
  rootContainer
}) => {
  const handlerArgRef = useHandlerRef(handlerArg);
  useEffect(() => {
    function handler(event) {
      if (typeof handlerArgRef.current === 'function') {
        handlerArgRef.current(event);
      }
    }
    rootContainer === null || rootContainer === void 0 || rootContainer.addEventListener('mousedown', handler);
    return () => {
      rootContainer === null || rootContainer === void 0 || rootContainer.removeEventListener('mousedown', handler);
    };
  }, [handlerArgRef, rootContainer]);
  return children;
};

export { OnRootContainerMousedown as O };
//# sourceMappingURL=OnRootContainerMousedown-I_k4tnAQ.js.map
